import { ArrowSmUpIcon } from '@heroicons/react/outline'
import classNames from 'classnames'
import LoadingIcon from 'components/atoms/LoadingIcon'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useTranslation } from 'react-i18next'

import { accessibleOnClick } from 'utils'

const Table = ({ onRowClick = () => {}, columns, fetchData, data = [], noTable, handleSort, sortBy, sortOrder, hasMore = true, bgRow, compact = false }) => {
  const { i18n } = useTranslation()
  const isRTL = i18n.language === 'ar'

  return (
    <div className="w-full min-w-0">
      <InfiniteScroll
        className="w-full min-w-0"
        style={compact ? undefined : { minHeight: 'calc(100vh - 54px)' }}
        dataLength={data.length} // This is important field to render the next data
        next={fetchData}
        scrollableTarget="rootScrollable"
        hasMore={hasMore}
        loader={
          <div style={{ width: '100%' }} className="h-[54px] flex justify-center items-center">
            <LoadingIcon />
          </div>
        }
      >
        <div className="w-full max-w-full overflow-x-auto overflow-y-visible">
          <table className="min-w-full w-max table-auto select-none">
            <thead>
              <tr className="border-gray-200 border-b">
                {!noTable &&
                  columns.map((column, index) => {
                    return (
                      <th
                        key={index}
                        width={column.width}
                        style={{ width: column.width || 'auto' }}
                        className={classNames(
                          'px-4 py-2 border-b border-gray-200 bg-gray-50 text-xs text-normal text-gray-500 uppercase tracking-wider',
                          isRTL ? 'text-right' : 'text-left'
                        )}
                      >
                        <div className={classNames('flex items-center', isRTL ? 'justify-end flex-row-reverse' : 'justify-start')}>
                          <span className="text-xs font-normal">{column.name}</span>
                          {column.sortable && (
                            <span
                              className={classNames(
                                sortBy === column.key && 'text-primary-500',
                                isRTL ? 'mr-2' : 'ml-2',
                                'h-6 w-6 hover:bg-gray-100 text-xs font-normal cursor-pointer rounded-full flex items-center justify-center'
                              )}
                              {...accessibleOnClick(() => {
                                if (sortBy === column.key) {
                                  if (sortOrder === 'asc') {
                                    handleSort(column.key, 'desc')
                                  } else if (sortOrder === 'desc') {
                                    handleSort(null, null)
                                  }
                                } else {
                                  handleSort(column.key, 'asc')
                                }
                              })}
                            >
                              <ArrowSmUpIcon className={classNames(sortBy === column.key && sortOrder === 'asc' && 'rotate-180', 'h-4 w-4')} />
                            </span>
                          )}
                        </div>
                      </th>
                    )
                  })}
              </tr>
            </thead>
            <tbody>
              {data.map((item, rowIndex) => {
                return (
                  <tr
                    onClick={onRowClick}
                    key={item?._id || item?.id || rowIndex}
                    className={classNames(!noTable && 'border-t border-gray-200', 'relative overflow-visible', bgRow || (rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-100'))}
                  >
                    {columns.map((column, columnIdx) => {
                      return (
                        <td
                          width={column.width}
                          style={{ width: column.width || 'auto' }}
                          key={columnIdx}
                          className={classNames(
                            noTable && 'p-0',
                            !noTable && 'px-4 py-2',
                            'relative overflow-visible whitespace-nowrap text-sm text-gray-900',
                            isRTL ? 'text-right' : 'text-left'
                          )}
                        >
                          {column.rendered(item, rowIndex)}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </InfiniteScroll>
    </div>
  )
}

export default Table
